import React, { useState } from 'react';
import './tabs.scss';

export interface TabBase {
  id: string;
  content?: JSX.Element | string;
  label?: string;
}

interface TabBaseProps extends TabBase {
  selected: boolean;
  onClick?: () => void;
}

const Tab: React.FC<TabBaseProps> = (props) => {
  const label = props.label || props.id
  const classes = props.selected ? ' tab_selected' : '';
  return (
    <div className='tab'>
      <span className={classes} onClick={props.onClick}>{label}</span>
    </div>
  );
};

export interface TabsBase<T extends TabBase> {
  selectedTab?: string;
  tabs: T[];
  onChange?: (tabId: string) => void;
}

type TabsBaseProps = TabsBase<TabBase>;

const Tabs: React.FC<TabsBaseProps> = (props) => {
  const classes = `tabs`;
  const selectedTab: TabBase | undefined = props.tabs.find((t) => t.id === props.selectedTab);
  const [tab, setTab] = useState(selectedTab)
  const onClick = (t: TabBase) => {
    if (tab && tab.id !== t.id) {
      setTab(t);
      props.onChange && props.onChange(t.id);
    }
  };
  return (
    <div className={classes}>
      <div className="tabs_names">
        {props.tabs.map((t) => (
          <Tab 
            id={t.id}
            key={'tab-' + t.id}
            label={t.label}
            selected={t.id === tab?.id}
            onClick={()=> onClick(t)} />
        ))}
      </div>
      {tab && tab.content ? (
        <div className="tabs_content">{tab.content}</div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Tabs;
